// @ts-nocheck
import * as React from "react";

const Trash2Line: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M13.659 2A2.42 2.42 0 0116 4.33V6h5a1 1 0 110 2h-1v11a3 3 0 01-3 3H7a3 3 0 01-3-3V8H3a1 1 0 110-2h5V4.33A2.42 2.42 0 0110.5 2zM18 8H6v11l.007.117A1 1 0 007 20h10a1 1 0 001-1V8zm-9 3a1 1 0 011 1v4a1 1 0 01-1 1l-.117-.007A1 1 0 018 16v-4a1 1 0 011-1zm6 0a1 1 0 011 1v4a1 1 0 01-1 1l-.117-.007A1 1 0 0114 16v-4a1 1 0 011-1zm-1.5-7h-3c-.29 0-.5.17-.5.33V6h4V4.33c0-.16-.21-.33-.5-.33z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(Trash2Line);
